import { render, staticRenderFns } from "./ProductPreviewForSupplier.vue?vue&type=template&id=49b9ac71&scoped=true&"
import script from "./ProductPreviewForSupplier.vue?vue&type=script&lang=js&"
export * from "./ProductPreviewForSupplier.vue?vue&type=script&lang=js&"
import style0 from "./ProductPreviewForSupplier.vue?vue&type=style&index=0&id=49b9ac71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b9ac71",
  null
  
)

export default component.exports